import React from 'react';

const LegendData1 = {
  Manuf: 'Laws, regulations, procedures on manufacturing',
  Transf: 'Laws, regulations, procedures on international transfers',
  Brok: 'Laws, regulations, procedures on brokering',
  Stockp: 'Standards and procedures on stockpile management',
  Destr: 'Capacity for destruction',
  Seiz: 'Capacity for confiscation and seizure',
  RecKp: 'Capacity for record-keeping',
  Traci: 'Procedures to trace SALW'
};

const LegendData2 = {
  NPC: 'National coordination mechanism / NPC',
  DDR: 'Disarmament support and put in place development',
  Train: 'Capacity-building and training on SALW issues',
  LawEnf: 'Law enforcement',
  Border: 'Customs and borders',
  Research: 'Action-oriented research',
  Children: 'Children and Youth',
  Awareness: 'Awareness-raising',
  Crime: 'Organized crime, drug trafficking and terrorism'
};

class AssistanceLandingSeekingCountriesLegend extends React.PureComponent {
  findTopicByAbbreviation(abbreviation) {
    const topic = Object.values(this.props.thematicDict)
      .find(item => {
        return item.abbreviation === abbreviation;
      });
    return topic;
  }

  getThematicColor(abbreviation) {
    const topic = this.findTopicByAbbreviation(abbreviation);
    return topic && topic.colorCode ? topic.colorCode : this.props.defaultColor;
  }

  renderTrs(data) {
    return Object.keys(data).map(key => {
      const label = data[key];
      return (
        <tr key={ key }>
          <td>
            <span
              className="tag-table-tag"
              style={{ backgroundColor: this.getThematicColor(key) }}
            >
              { key }
            </span>
          </td>
          <td>{ label }</td>
        </tr>
      )
    });
  }

  renderTable(data) {
    return (
      <table className="assistance-seeking__legend-table">
        { this.renderTrs(data) }
      </table>
    );
  }

  render() {
    return (
      <div className="assistance-seeking__legend">
        { this.renderTable(LegendData1) }
        { this.renderTable(LegendData2) }
      </div>
    );
  }
}

export default AssistanceLandingSeekingCountriesLegend;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/AssistanceLandingSeekingCountriesLegend.js